import { Component, Input } from '@angular/core'

interface Stats {
  label: string
  value: number
  suffix?: string
  icon?: string
  compValue?: number
  percent?: number
}

@Component({
  standalone: false,
  selector: 'app-stats-widget',
  templateUrl: './stats-widget.component.html',
  styleUrls: ['./stats-widget.component.scss'],
})
export class StatsWidgetComponent {
  @Input() infoTooltip: string
  @Input() stats: Stats[] = []
  @Input() isMultiple = false
  @Input() referenceLabel = 'Reference'
  @Input() comparedLabel = 'Compared'

  get first() {
    return this.stats[0]
  }

  get details() {
    return this.stats.slice(1)
  }

  hasDetails() {
    return this.stats.length > 1
  }
}
